import { Button, Dialog } from '@optimus-web/core';
import { lt } from '@mews/framework';
import {
    useLoyaltyMembershipErrorDialog,
    useLoyaltyMembershipErrorDialogState,
} from './useLoyaltyMembershipErrorDialog';

export const LoyaltyMembershipErrorDialog = () => {
    const { closeDialog } = useLoyaltyMembershipErrorDialog();
    const active = useLoyaltyMembershipErrorDialogState();

    return (
        <Dialog
            active={active}
            onClose={closeDialog}
            title={lt('LookupLoyaltyErrorDialogTitle')}
            footer={{
                primary: (
                    <Button size="medium" variant="primary" onClick={closeDialog} type="submit">
                        {lt('Ok')}
                    </Button>
                ),
            }}
        >
            {lt('LookupLoyaltyErrorDialogContent')}
        </Dialog>
    );
};
